import React from "react";
import {
    Grid,
    Button,
    TextField,
    Box,
    IconButton,
    CircularProgress,
} from "@material-ui/core";
import {
    AddCircleOutline,
    RemoveCircleOutline,
    HorizontalRule,
 } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    separator: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    validateButton: {
        marginTop: theme.spacing(1.5),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    inputBackground: {
        backgroundColor: "#ffffff",
    },
    iconButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 52,
        minHeight: 52,
        backgroundColor: "#ffffff",
        borderRadius: 4,
    },
    icon: {
        fontSize: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    iconGroup: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
}));

export default function RangeNumberInputComponent({
    ranges,
    onRangeChange,
    onAddRange,
    onRemoveRange,
    onValidate,
    isValidating,
    isValidateDisabled,
    selectedMethod,
}) {
    const classes = useStyles();

    const label =
        selectedMethod === "seq_num" ? "Sequence Number" : "Serial Number";

    return (
        <Grid container spacing={1} alignItems="center">
            {ranges.map((range, idx) => (
                <React.Fragment key={range.id}>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          className={classes.inputBackground}
                          label={`From (${label})`}
                          variant="outlined"
                          value={range.from}
                          onChange={(e) => onRangeChange(idx, "from", e.target.value)}
                          disabled={isValidating}
                        />
                    </Grid>
                    <Grid item xs={1} className={classes.separator}>
                        <HorizontalRule fontSize="small" />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          className={classes.inputBackground}
                          label={`To (${label})`}
                          variant="outlined"
                          value={range.to}
                          onChange={(e) => onRangeChange(idx, "to", e.target.value)}
                          disabled={isValidating}
                        />
                    </Grid>
                    <Grid item xs="auto">
                      <Box className={classes.iconGroup}>
                        <IconButton
                          className={classes.iconButton}
                          onClick={() => onRemoveRange(idx)}
                          disabled={isValidating}
                          aria-label="Remove Range"
                        >
                            <RemoveCircleOutline color="error" className={classes.icon} />
                        </IconButton>
                        <IconButton
                          className={classes.iconButton}
                          onClick={onAddRange}
                          disabled={isValidating}
                          aria-label="Add Range"
                        >
                            <AddCircleOutline color="primary" className={classes.icon} />
                        </IconButton>
                      </Box>
                    </Grid>
                </React.Fragment>
            ))}
            <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onValidate}
                  disabled={isValidateDisabled}
                >
                    {isValidating ? (
                      <>
                        Validating...
                        &nbsp;
                        <CircularProgress size={16} color="inherit" />
                      </>
                    ) : (
                      "Validate"
                    )}
                </Button>
            </Grid>
        </Grid>
    );
}
